import { Service, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { first } from 'rxjs';
import { LocalizationService } from './localization.service';
import { Keyword } from './models';

@Service()
export class TitleService extends TitleStrategy {
    private readonly title = inject(Title);
    private readonly localizationService = inject(LocalizationService);

    constructor() {
        super();
    }

    public override updateTitle(routerState: RouterStateSnapshot) {
        const titleKey = this.buildTitle(routerState);
        if (titleKey !== undefined) {
            this.localizationService
                .getTranslation(titleKey as Keyword)
                .pipe(first())
                .subscribe(translatedTitle => {
                    this.title.setTitle(`Askemo - ${translatedTitle}`);
                });
        } else {
            this.title.setTitle('Askemo');
        }
    }
}
